import React, { useState } from 'react'
import { Panel, SelectPicker, DatePicker, Input, Row, Col } from 'rsuite'
import DatePickerCustom from '../../../components/datePicker/DatePickerCustom'
import moment from 'moment'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function AssetSendBackEditListsForm({
  schema,
  loading,
  onSearch = () => {},
  ...props
}) {
  const [projectCode, setProjectCode] = useState()
  const [projectName, setProjectName] = useState()
  const [assetCode, setAssetCode] = useState()
  const [assetName, setAssetName] = useState()
  const [assetClosureCode, setAssetClosureCode] = useState()
  const [assetRegisterCode, setAssetRegisterCode] = useState()
  const [assetStatus, setAssetStatus] = useState()
  const [reviewEndDate, setReviewEndDate] = useState()
  const [reviewStartDate, setReviewStartDate] = useState()

  const handleSearch = async () => {
    // console.log('handleSearch')
    let request = {
      projectCode: projectCode,
      projectName: projectName,
      assetCode: assetCode,
      assetName: assetName,
      assetClosureCode: assetClosureCode,
      assetRegisterCode: assetRegisterCode,
      assetStatus: assetStatus,
      reviewEndDate: reviewEndDate ? moment(reviewEndDate).format('YYYY-MM-DD') : '',
      reviewStartDate: reviewStartDate ? moment(reviewStartDate).format('YYYY-MM-DD') : '',
    }
    onSearch(request)
  }

  const handleCancel = async () => {
    // console.log('handleCancel')
    setProjectCode('')
    setProjectName('')
    setAssetCode('')
    setAssetName('')
    setAssetClosureCode('')
    setAssetRegisterCode('')
    setAssetStatus('')
    setReviewEndDate('')
    setReviewStartDate('')
    onSearch({})
  }

  return (
    <>
      <Panel header={'ค้นหา'} bordered collapsible defaultExpanded>
        <Row style={{ marginTop: -10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.projectCode.label}
            <Input
              placeholder={schema.projectCode.hint || schema.projectCode.label}
              value={projectCode}
              onChange={(value) => {
                setProjectCode(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.projectName.label}
            <Input
              placeholder={schema.projectName.hint || schema.projectName.label}
              value={projectName}
              onChange={(value) => {
                setProjectName(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.reviewStartDate.label}
            <DatePickerCustom
              {...props}
              placement="auto"
              value={reviewStartDate}
              disabledDate={(date) =>
                reviewEndDate && moment(reviewEndDate).isBefore(date, new Date())
              }
              onChange={(value) => {
                setReviewStartDate(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.reviewEndDate.label}
            <DatePickerCustom
              {...props}
              placement="auto"
              value={reviewEndDate}
              disabledDate={(date) =>
                reviewStartDate && moment(reviewStartDate).isAfter(date, new Date())
              }
              onChange={(value) => {
                setReviewEndDate(value)
              }}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetCode.label}
            <Input
              placeholder={schema.assetCode.hint || schema.assetCode.label}
              value={assetCode}
              onChange={(value) => {
                setAssetCode(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetName.label}
            <Input
              placeholder={schema.assetName.hint || schema.assetName.label}
              value={assetName}
              onChange={(value) => {
                setAssetName(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetClosureCode.label}
            <Input
              placeholder={schema.assetClosureCode.hint || schema.assetClosureCode.label}
              value={assetClosureCode}
              onChange={(value) => {
                setAssetClosureCode(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetRegisterCode.label}
            <Input
              placeholder={schema.assetRegisterCode.hint || schema.assetRegisterCode.label}
              value={assetRegisterCode}
              onChange={(value) => {
                setAssetRegisterCode(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetStatus.label}
            <SelectPicker
              searchable={false}
              data={schema.assetStatus.options}
              value={assetStatus}
              block
              placeholder={`เลือก${schema.assetStatus.label || ''}`}
              onChange={(value) => {
                setAssetStatus(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <div style={{ marginTop: 30 }}>
              <SearchButton
                disabled={loading}
                onClick={handleSearch}
                style={{ marginTop: 0, marginLeft: 0 }}
              >
                ค้นหา
              </SearchButton>
              <CancelButton onClick={handleCancel} style={{ marginTop: 0, marginLeft: 10 }}>
                ยกเลิก
              </CancelButton>
            </div>
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>
      </Panel>
    </>
  )
}
